export const APAC_TRAVELERS_NAME = "apac-travelers";
export enum ApacTravelersComponent {
  DriverLicense = "DriverLicense",
  TravellerForm = "TravellerForm",
  PassportDetails = "PassportDetails",
  FrequentFlyerDetails = "FrequentFlyerDetails",
  AdditionalInfo = "AdditionalInfo",
}
